import logger from '../../services/logger';

import React, { useState } from 'react';
import AuthService from "../../services/auth.service";
import SearchService from "../../services/search.service";
import UploadServiceInstance from "../../services/upload.service";

import NewDeviceForm from './NewDeviceForm';
import RadioButtonChoice from '../common/RadioButtonChoice';
import ImageUploader from '../common/ImageUploader';
import WaitingModal from '../common/WaitingModal';

const NewDeviceDetection = ({univerChoice, getAppliance }) => {
  const [pict, setPict] = useState(null);
  //const [pictURL, setPictURL] = useState(null);
  const [addMethod, setAddMethod] = useState("");
  const [precision, setPrecision] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const [errorMessage, setErrorMessage] = useState(''); // État pour le message d'erreur


  const addMethods = [
    { id: 'manual', value: 'manual', label: 'Entrée manuelle' },
    { id: 'imageDetection', value: 'imageDetection', label: 'Reconnaissance d\'image' },
    { id: 'factureDetection', value: 'factureDetection', label: 'Recherche sur la facture' },
  ];

  const handleFactureUploadAndAnalyse = async () => {
    setIsLoading(true);
    setErrorMessage('');
    try {
      const result = await SearchService.analyseFacture(pict);
      logger.log("Résultat", result);

      // Transforme le résultat en `appliance` si possible
      const appliance = {
        marque: result.marque || '',
        modele: result.modele || '',
        prix: result.prix || '',
        date_achat: result.date_achat || '',
        magasin: result.magasin || '',
        univer_id: univerChoice.id || univerChoice.uuid,
      };

      getAppliance(appliance); // Retour vers AddDevicePage
    } catch (err) {
      logger.log('Erreur analyse facture :', err);
      setErrorMessage("Une erreur est survenue lors de l'analyse de la facture.");
    } finally {
      setIsLoading(false);
    }
  };


  const handleImageUpload = (uploadedUrl, uploadedImage) => {
    setPict(uploadedImage);
    //setPictURL(uploadedUrl);
  };

  const handleSearchClick = async () => {
    setIsLoading(true);
    logger.log('*****************before search  :');
    try {
      const user = AuthService.getCurrentUser();
      const uploadResult = await UploadServiceInstance.uploadTempFile(pict);
      const url = uploadResult ? uploadResult.fileUrl : "";
      const textToSearch = precision ? `${precision}` : 'machine';
      const univerId = univerChoice.id ? univerChoice.id : univerChoice.uuid;
      
      // Appel du service de recherche pour obtenir `appliance`
      const appliance = await SearchService.searchAndSaveByImage(url, textToSearch, user.id, univerId, 15);
      logger.log('*****************appliance  :', appliance);
      // Appel de `createAppliance` pour envoyer `appliance` à `AddDevicePage` si appliance est crée avec succès
      if (appliance) getAppliance(appliance);
      else {
        setErrorMessage("Veuillez apporter plus de précision à la recherche."); // Définir le message d'erreur
      }
    } catch (error) {
      logger.log('Erreur lors de la recherche :', error);
      setErrorMessage("Une erreur est survenue lors de la recherche."); // Message d'erreur générique en cas de problème
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      

      {(
        <div>
          <p className="mt-3 text-medium text-center">Détails de ton appareil</p>
          <ImageUploader onImageUpload={handleImageUpload} />
        </div>
      )}

      
      {pict && (
        <RadioButtonChoice className=""
          legend={`Comment l’intégrer dans "${univerChoice.name}"`}
          options={addMethods}
          selectedValue={addMethod}
          onChange={setAddMethod}
        />
      )}

      {addMethod === 'manual' && <NewDeviceForm />}

      {addMethod === 'imageDetection' && (
        <div>
         <p className="mt-3 text-small" style={{ fontStyle: 'italic' }}>Ajoutez une précision pour faciliter la recherche (facultatif)</p>
         <input
            type="text"
            maxLength="50"
            className="form-control text-small mb-3"
            onChange={(e) => setPrecision(e.target.value)}
          />  


          {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}

          <button onClick={handleSearchClick} className="mt-3 btn btn-primary btn-block" type="submit">
            Rechercher
          </button>
        </div>
      )}

      {addMethod === 'factureDetection' && (
        <div>
          {errorMessage && <p style={{ color: 'red' }}>{errorMessage}</p>}
          <p className="mt-3 text-small">Ajoutez une image ou un PDF de votre facture d'achat (max 2 Mo)</p>
          <ImageUploader onImageUpload={handleImageUpload} />
          <button onClick={handleFactureUploadAndAnalyse} className="mt-3 btn btn-primary btn-block" type="button">
            Lire la facture
          </button>
        </div>
      )}

      {isLoading && <WaitingModal />}
      <br/>
    </div>
  );
};

export default NewDeviceDetection;
